<script>
  import config from '../../libs/config.js';
  import { mapGetters, mapActions } from 'vuex'
  
  import api from '../../api/public'
  import api_private from '../../api'

  import _system from '../../libs/system';

  import axios from 'axios'

  import AOS from 'aos'
  import 'aos/dist/aos.css'

	export default 
	{
    name: 'forgotPassword',
    data(){
      return {
        loading: false,
        mobile: false,
        show: false,
        tokenBody: '',
        tokenUser: {},
        succeed: false,
        signIn: {
          email: ''
        },
        error: {
          email: {
            invalid: false,
            notExist: false
          },
          password: {
            invalid: false
          }
        }
      }
    },
    mounted(){

        let domain = window.location.hostname.toString();

        if(domain == 'app.juphy.com'){

          this.show = true
        }
    },
    created(){
      AOS.init();

      if( navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i) ) this.mobile = true;


      


    },
    computed:{
      ...mapGetters('session', ['isLoggedIn', , 'getUser', 'getJwt'])
    },
    methods: 
      {
        ...mapActions('session', ['login', 'setIsLoggedIn', 'setWorkspace']),
        ...mapActions('networks', ['setNetworks']),
        ...mapActions('statuses', ['setStatuses']),
        forgotPassword()
        {

        if(!this.signIn.email.length ){
            return alert('Inputs cannot be empty')
        }

          this.loading = true;

          this.signIn.email = this.signIn.email.trim();

          let payload = {
            query: {
              email: this.signIn.email
            }
          }
          
          _system.services.user.forgotPassword(payload, (err, data) => {
              if(err) {
                console.log(err)
                this.loading = false
                this.error.message = err.data.message
                return this.error.email.invalid = true;
            }

             this.succeed = true;

              this.loading = false


          });
		    }
		}
	}
</script>

<template>
		<div :class="(mobile) ? 'ui grid stackable padded' : 'ui grid stackable middle aligned padded'">
      <div class="six wide column centered">
        <div v-if="show" data-aos="zoom-in" class="ui basic segment">
          <img class="ui image centered" style="width: 170px;" src="/img/logo_white7.png" alt="">
        </div>
        <div class="ui basic segment">
              <div v-show="succeed" class="ui positive message ">
                <p>Please check your email address {{signIn.email}}</p>
              </div>
            <div v-show="!succeed" class="ui form">
              <div class="field">
                  <label>Email</label>
                  <input v-model="signIn.email" @input="signIn.email=$event.target.value.toLowerCase().trim()" placeholder="eric@southpark.com" type="text" :disabled="loading">
              </div>
              <div v-show="error.email.invalid" class="ui negative mini message ">
                <p>{{error.message}}</p>
              </div>
              <div class="field">
                <button v-bind:class="{loading: loading}" :disabled="loading" @click="forgotPassword()" class="ui orange button fluid">Send Reset Link</button>
              </div>
              <p  style="font-size:12px; text-align: right;">Go back to <router-link  to="/signin"><a href="">login</a></router-link></p>
            </div>
          </div>     
        </div>
      </div>
</template>


// WEBPACK FOOTER //
// src/components/auth/forgotPassword.vue